import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';

import './index.scss';

type TextBlockProps = {
  children: React.ReactNode;
  variant: TextBlockVariant;
  leading?: React.ReactNode;
  leadingIcon?: IconDefinition;
};

type TextBlockVariant = 'L-semi-bold' | 'L-regular-1L' | 'L-regular' | 'M-semi-bold' | 'S-regular' | 'XXS-regular-error-message' | 'XXS-regular-hint-text';

export const TextBlock = ({ children, variant, leading, leadingIcon }: TextBlockProps) => {
  return (
    <div className={`myd-text-block myd-text-block-wrapper myd-text-block--${variant}`}>
      {leading && <div className={`myd-text-block--${variant}--leading`}>{leading}</div>}
      {leadingIcon && <FontAwesomeIcon icon={leadingIcon} className={`myd-text-block--${variant}--leading-icon`} aria-hidden />}
      <div className={`myd-text-block--text myd-text-block--${variant}--text`}>{children}</div>
    </div>
  );
};

export default TextBlock;
